<template>
  <div class="home" :class="backing">
    <section class="hero is-medium is-dark">
      <div class="hero-body">
        <div class="container">
          <img alt="Crusade Cloud" src="../assets/logo.png" id="logo">
          <h1 class="title">
            Your Convenient Crusade Companion
          </h1>
          <h2 class="subtitle">
            Manage Warhammer 40k crusade forces with ease
          </h2>
        </div>
      </div>
    </section>
  </div>
  
</template>

<script>
export default {
  computed: {
    backing() {
      return `back${Math.ceil(Math.random() * 6)}`
    }
  }
}
</script>

<style lang="scss" scoped>

  @media screen and (min-width: 769px) {
    .hero.is-medium .hero-body {
      padding-top:3rem;
      padding-bottom:3rem;

    }
  }

  .home {
    text-align: center;
    background-size: cover;
    background-color: #333;
    border-bottom: solid 1px #999;

    .hero.is-dark { background: rgba(0,0,0,0.3); }
  
    #logo { 
      // margin-top: 1em; 
      width: 200px;
    }
    // h1 {
    //   color: #fff;
    //   padding-bottom: 2em;
    //   margin:0;
    // }

    
  }
  .home.back1 { background-image: url('../assets/backgrounds/planet.jpg') ; }
  .home.back2 { background-image: url('../assets/backgrounds/spaceship.jpg') ; }
  .home.back3 { background-image: url('../assets/backgrounds/space.jpg') ; }
  .home.back4 { background-image: url('../assets/backgrounds/universe.jpg') ; }
  .home.back5 { background-image: url('../assets/backgrounds/space-red.jpg') ; }
  .home.back6 { background-image: url('../assets/backgrounds/turmoil.jpg') ; }
    
</style>